"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _is = _interopRequireDefault(require("ramda/src/is"));
var _useValidation = require("../Hook/useValidation");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type JSONSchema } from '@catalytic/json-schema-validator-catalytic-web';*/
var isBlob = (0, _is.default)(window.Blob);
var isFileSchemaAndBlobValue = function isFileSchemaAndBlobValue(schema /*: JSONSchema<>*/, value /*: any*/) {
  return (schema === null || schema === void 0 ? void 0 : schema.refType) === 'FILE' && isBlob(value);
};
var isFileSchemaAndEmptyStringValue = function isFileSchemaAndEmptyStringValue(schema /*: JSONSchema<>*/, value /*: any*/) {
  return (schema === null || schema === void 0 ? void 0 : schema.refType) === 'FILE' && value === '';
};
var getErrorMessage = function getErrorMessage(_ref /*:: */) {
  var contextValues = _ref /*:: */.contextValues,
    name = _ref /*:: */.name,
    schemaProp = _ref /*:: */.schema,
    valueProp = _ref /*:: */.value;
  if (schemaProp === undefined ||
  // If the value is null or an empty string, we don't care about the error
  // message (like "Must be string"). Our forms will already apply the error
  // styling for required fields and the data type error message is not
  // meaningful to users.
  valueProp === null || valueProp === '' ||
  // Since json-schema-validator considers file blobs to be invalid
  // for file fields and there's no immediate value to supporting them,
  // we skip file blob validation for now.
  isFileSchemaAndBlobValue(schemaProp, valueProp) ||
  // When a file is removed from a file input, the field's value get's
  // set to an empty string. We still want to ignore the schema error
  // and just let the existing form validation handle the required field.
  isFileSchemaAndEmptyStringValue(schemaProp, valueProp)) {
    return;
  }
  var schema;
  var value;
  if (contextValues === undefined) {
    schema = schemaProp;
    value = valueProp;
  } else {
    schema = {
      properties: (0, _defineProperty2.default)({}, name, schemaProp),
      type: 'object'
    };
    value = _objectSpread(_objectSpread({}, contextValues), {}, (0, _defineProperty2.default)({}, name, valueProp));
  }
  var fieldSchemaValidation = (0, _useValidation.createValidation)({
    schema: schema,
    value: value
  });
  var fieldSchemaValidationErrors = (fieldSchemaValidation.errors || []).filter(function (error) {
    var _split = (error.dataPath || '').split('/'),
      _split2 = (0, _slicedToArray2.default)(_split, 2),
      index = _split2[1];
    return name === index;
  });
  var schemaValidation = (0, _useValidation.createValidation)({
    schema: schemaProp,
    value: valueProp
  });
  var schemaValidationErrors = schemaValidation.errors || [];
  var validationErrors = [].concat((0, _toConsumableArray2.default)(fieldSchemaValidationErrors), (0, _toConsumableArray2.default)(schemaValidationErrors)) || [];
  var error = (0, _toConsumableArray2.default)(validationErrors || []).pop();
  var errorMessage = error === null || error === void 0 ? void 0 : error.message;
  return errorMessage;
};
var _default = exports.default = getErrorMessage;
//# sourceMappingURL=getErrorMessage.js.map